<template>

    <div class="modal modal-question fade in show" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <div class="modal-inner">
                    <h5 class="title">Edit</h5>
                    <div class="form">
                        <form action="">
                            <label class="form-group">
                                <span class="form-label">Name</span>
                                <input type="text" v-model="inputValue" class="form-control pl-4">
                            </label>
                            <div class="buttons">
                                <button
                                    class="btn btn_primary-outline pl-5 pr-5"
                                    @click="closeModal"
                                > {{ rejectText }}</button>
                                <button
                                    class="btn btn_golden"
                                    @click.prevent="confirmation"
                                >
                                    <span class="pl-5 pr-5">{{ confirmText }}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: 'ActionModalWithInput',
    data() {
        return {
            inputValue: null,
        }
    },
    mounted() {
        this.inputValue = this.title ?? null
    },
    props: {
        confirmText: String,
        modalId: {
            type: String,
            required: true,
        },
        rejectText: String,
        title: String,
    },
    emits: ['confirm'],
    methods: {
        closeModal() {
            $(`#${this.modalId}`).modal('hide');
        },
        confirmation () {
            $(`#${this.modalId}`).modal('hide');
            this.$emit('confirm', this.inputValue);
        }
    }
}

</script>



<style scoped>

</style>
